import React from 'react';
import PropTypes from 'prop-types';
import IconButton from "../../../../components/blocks/IconButton";
import { ProgramLocalResult } from "../../../../services/programs/models/ProgramTypes";
import { useTranslation } from "react-i18next";
import useSystemDateTheme from "../../../../hooks/useSystemDateTheme";
import { useNavigate } from "react-router-dom";

type ProgramCardProp = {
    program: ProgramLocalResult;
}
const ProgramCard = ({ program }:ProgramCardProp) => {
    const { t, i18n } = useTranslation("WelcomePage");
    const { toSystemThemeDateFormat } = useSystemDateTheme();
    const navigate = useNavigate();

    return (
        <div
            key={program.id}
            className="shadow bg-white d-flex flex-column flex-md-row gap-3 border rounded-4 p-3 flex-grow-1"
            style={{ maxWidth:"calc(50% - 1rem)" , width: "calc(50% - 1rem)", minWidth:200 }}
        >
            <img
                src={program.adsImage}
                className="rounded-4"
                alt={program.programDetail.description}
                style={{ width: "100%", maxWidth: 140, height: "auto" }}
            />
            <div className="d-flex flex-column gap-1 justify-content-between flex-grow-1">
                <div className="d-flex flex-column gap-1">
                    <span className="fs-6">{program.programType}</span>
                    <h4 className="fs-5">{program.programDetail.displayName}</h4>
                    <p className="truncate-2lines" data-bs-toggle="tooltip" title={program.programDetail.description}>
                        {program.programDetail.description}
                    </p>
                </div>
                <div className="d-flex gap-2 text-dark flex-wrap">
                    {program.adsEndDate && (
                        <div>
                            <div className="text-gray small">{t("closeDate")}</div>
                            <div className="border rounded-4 p-2 text-center small" style={{ width: 75 }}>
                                {toSystemThemeDateFormat(program.adsEndDate)}
                            </div>
                        </div>
                    )}
                    <div>
                        <div className="text-gray small">{t("audiencesType")}</div>
                        <div className="border rounded-4 p-2 text-center small">
                            {program.audienceTypes.map(ele  => ele.audienceTypeDetail.displayName).join(" ,")}
                        </div>
                    </div>
                    <div className="flex-1 p-1"></div>
                    <IconButton
                        icon={i18n.language === "ar" ? "icon-arrow-left" : "icon-arrow-right"}
                        variant="primary"
                        className="rounded-50 align-self-end"
                        fitToIconWidth
                        style={{ width: 40, height: 40 }}
                        onClick={() => navigate(`/programDetails/${program.id}`)}
                    />
                </div>
            </div>
        </div>
    );
};

export default ProgramCard;
